import { render } from "./App.vue?vue&type=template&id=43f35d76"
const script = {}

import "./App.vue?vue&type=style&index=0&id=43f35d76&lang=css"
script.render = render

export default script